export const removeVPS =
  (vpsProductId) =>
  async (dispatch, getState, { api }) =>
    api.removeVPS(vpsProductId).then(
      (isSuccess) => isSuccess,
      (err) => {
        console.error("Removing VPS product from the basket failed", err);
      },
    );
